import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Shield } from 'lucide-react';
export function PrivacyPolicyPage() {
  return <div className="min-h-screen bg-offwhite font-sans text-navy" data-id="element-666">
      <Navbar data-id="element-667" />
      <main className="pt-28 pb-20" data-id="element-668">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-669">
          {/* Header */}
          <div className="text-center mb-12" data-id="element-670">
            <div className="w-14 h-14 bg-navy/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-671">
              <Shield className="w-7 h-7 text-navy" data-id="element-672" />
            </div>
            <h1 className="text-3xl md:text-4xl font-heading font-bold text-navy mb-3" data-id="element-673">
              Privacy Policy
            </h1>
            <p className="text-gray-500 text-sm" data-id="element-674">
              Last Updated: 24 February 2026
            </p>
          </div>

          {/* Content Card */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 md:p-12 space-y-10" data-id="element-675">
            <p className="text-gray-600 leading-relaxed" data-id="element-676">
              De Rien Cash Loan (Pty) Ltd ("De Rien", "we", "us", "our")
              respects your privacy and is committed to protecting your personal
              information.
            </p>

            <Section title="1. About This Policy" data-id="element-677">
              <p data-id="element-678">
                This Privacy Policy explains how we collect, use, share, store,
                and protect your personal information when you:
              </p>
              <ul data-id="element-679">
                <li data-id="element-680">Visit our website</li>
                <li data-id="element-681">Submit an online or physical loan application</li>
                <li data-id="element-682">Contact us via phone, email, or in person</li>
                <li data-id="element-683">Use our financial services</li>
              </ul>
            </Section>

            <Section title="2. Information We Collect" data-id="element-684">
              <p data-id="element-685">
                We may collect and process the following categories of
                information:
              </p>
              <SubSection title="2.1 Personal Details" data-id="element-686">
                <ul data-id="element-687">
                  <li data-id="element-688">
                    Full names, title, and identity details (Omang/Passport)
                  </li>
                  <li data-id="element-689">Date of birth, gender, marital status</li>
                  <li data-id="element-690">Nationality and residential status</li>
                </ul>
              </SubSection>
              <SubSection title="2.2 Contact Details" data-id="element-691">
                <ul data-id="element-692">
                  <li data-id="element-693">Physical and postal address</li>
                  <li data-id="element-694">Email address and telephone numbers</li>
                </ul>
              </SubSection>
              <SubSection title="2.3 Employment Details" data-id="element-695">
                <ul data-id="element-696">
                  <li data-id="element-697">
                    Employer name, occupation, date of appointment, length of
                    service
                  </li>
                  <li data-id="element-698">Salary information (including gross salary)</li>
                </ul>
              </SubSection>
              <SubSection title="2.4 Financial Details" data-id="element-699">
                <ul data-id="element-700">
                  <li data-id="element-701">
                    Loan amount requested, repayment period, deduction method
                  </li>
                  <li data-id="element-702">Existing loan facilities and repayment information</li>
                  <li data-id="element-703">Bank statements and payslips</li>
                </ul>
              </SubSection>
              <SubSection title="2.5 Supporting Documents" data-id="element-704">
                <ul data-id="element-705">
                  <li data-id="element-706">Identity documents</li>
                  <li data-id="element-707">Confirmation letter of employment</li>
                  <li data-id="element-708">Three (3) months bank statements</li>
                  <li data-id="element-709">Work and residence permits (where applicable)</li>
                  <li data-id="element-710">
                    KYC documentation (collected through our application
                    process)
                  </li>
                </ul>
              </SubSection>
            </Section>

            <Section title="3. How We Use Your Information" data-id="element-711">
              <p data-id="element-712">We use your information to:</p>
              <ul data-id="element-713">
                <li data-id="element-714">Receive and process your loan application</li>
                <li data-id="element-715">Verify your identity and comply with KYC requirements</li>
                <li data-id="element-716">
                  Conduct affordability checks and credit risk assessments
                </li>
                <li data-id="element-717">Communicate with you about your application and account</li>
                <li data-id="element-718">Disburse funds and manage repayments</li>
                <li data-id="element-719">Maintain internal records, reporting, and auditing</li>
                <li data-id="element-720">
                  Prevent, detect, and investigate fraud or financial crime
                </li>
                <li data-id="element-721">Comply with legal and regulatory obligations</li>
              </ul>
              <p className="mt-4 font-medium text-navy" data-id="element-722">
                We do not sell your personal information.
              </p>
            </Section>

            <Section title="4. Legal Basis for Processing" data-id="element-723">
              <p data-id="element-724">We process personal information on the basis of:</p>
              <ul data-id="element-725">
                <li data-id="element-726">
                  <strong data-id="element-727">Consent</strong> (where required)
                </li>
                <li data-id="element-728">
                  <strong data-id="element-729">Contractual necessity</strong> (to provide loan
                  services)
                </li>
                <li data-id="element-730">
                  <strong data-id="element-731">Legal obligation</strong> (regulatory and compliance
                  duties)
                </li>
                <li data-id="element-732">
                  <strong data-id="element-733">Legitimate interests</strong> (such as fraud
                  prevention and service improvement)
                </li>
              </ul>
            </Section>

            <Section title="5. Sharing of Information" data-id="element-734">
              <p data-id="element-735">
                We may share your information only when necessary, including
                with:
              </p>
              <ul data-id="element-736">
                <li data-id="element-737">Credit bureaus and identity verification providers</li>
                <li data-id="element-738">
                  Banking/payment partners and service providers supporting
                  processing
                </li>
                <li data-id="element-739">
                  Regulators, law enforcement, or authorities (where required)
                </li>
                <li data-id="element-740">
                  Auditors, legal advisors, and professional consultants (when
                  applicable)
                </li>
              </ul>
              <p className="mt-3" data-id="element-741">
                Where third parties process information on our behalf, we
                require reasonable safeguards and confidentiality.
              </p>
            </Section>

            <Section title="6. Data Security" data-id="element-742">
              <p data-id="element-743">
                We take reasonable technical and organisational measures to
                protect your information, including:
              </p>
              <ul data-id="element-744">
                <li data-id="element-745">Access control (restricted staff access)</li>
                <li data-id="element-746">Secure storage and controlled document handling</li>
                <li data-id="element-747">Data transmission safeguards (where applicable)</li>
              </ul>
              <p className="mt-3" data-id="element-748">
                While we take security seriously, no system can guarantee
                absolute security.
              </p>
            </Section>

            <Section title="7. Data Retention" data-id="element-749">
              <p data-id="element-750">We retain personal information:</p>
              <ul data-id="element-751">
                <li data-id="element-752">For as long as necessary to provide our services</li>
                <li data-id="element-753">
                  For the period required by applicable laws and regulations
                </li>
                <li data-id="element-754">
                  For audit, dispute resolution, and legal enforcement purposes
                </li>
              </ul>
              <p className="mt-3" data-id="element-755">
                When no longer required, information is securely deleted or
                anonymised.
              </p>
            </Section>

            <Section title="8. Your Rights" data-id="element-756">
              <p data-id="element-757">Subject to applicable laws, you may request to:</p>
              <ul data-id="element-758">
                <li data-id="element-759">Access your personal information</li>
                <li data-id="element-760">Correct inaccurate or incomplete information</li>
                <li data-id="element-761">Withdraw consent (where processing relies on consent)</li>
                <li data-id="element-762">Object to certain processing activities</li>
                <li data-id="element-763">Request deletion (where legally permissible)</li>
              </ul>
              <p className="mt-3" data-id="element-764">
                To make a request, contact us using the details in Section 11.
              </p>
            </Section>

            <Section title="9. Cookies & Website Analytics" data-id="element-765">
              <p data-id="element-766">Our website may use cookies and similar technologies to:</p>
              <ul data-id="element-767">
                <li data-id="element-768">Improve user experience</li>
                <li data-id="element-769">Monitor performance and security</li>
                <li data-id="element-770">Understand how visitors use our website</li>
              </ul>
              <p className="mt-3" data-id="element-771">
                You can control cookies via your browser settings. Disabling
                cookies may affect some features.
              </p>
            </Section>

            <Section title="10. Third-Party Links" data-id="element-772">
              <p data-id="element-773">
                Our website may include links to third-party websites. We are
                not responsible for the privacy practices or content of those
                websites. We encourage you to review their policies.
              </p>
            </Section>

            <Section title="11. Contact Us" data-id="element-774">
              <p data-id="element-775">
                If you have questions about this Privacy Policy or how we handle
                personal information, contact:
              </p>
              <div className="mt-4 bg-offwhite rounded-xl p-6 text-sm text-gray-700 space-y-1 border border-gray-100" data-id="element-776">
                <p className="font-bold text-navy" data-id="element-777">
                  De Rien Cash Loan (Pty) Ltd
                </p>
                <p data-id="element-778">Plot 20582, Block 3, Unit 9/10, Gaborone</p>
                <p data-id="element-779">P.O Box 3568, Gaborone</p>
                <p data-id="element-780">
                  Email:{' '}
                  <a href="mailto:derien@derien.co.bw" className="text-navy underline" data-id="element-781">
                    derien@derien.co.bw
                  </a>
                </p>
                <p data-id="element-782">
                  Tel:{' '}
                  <a href="tel:+26774833041" className="text-navy underline" data-id="element-783">
                    +267 74 833 041
                  </a>{' '}
                  /{' '}
                  <a href="tel:+26777685555" className="text-navy underline" data-id="element-784">
                    +267 77 685 555
                  </a>
                </p>
              </div>
            </Section>
          </div>

          <div className="text-center mt-8" data-id="element-785">
            <a href="#" className="text-sm text-gray-500 hover:text-navy transition-colors" data-id="element-786">
              ← Back to Home
            </a>
          </div>
        </div>
      </main>
      <Footer data-id="element-787" />
    </div>;
}
function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div data-id="element-788">
      <h2 className="text-xl font-heading font-bold text-navy mb-4 pb-2 border-b border-gray-100" data-id="element-789">
        {title}
      </h2>
      <div className="text-gray-600 leading-relaxed space-y-3 text-sm" data-id="element-790">
        {children}
      </div>
    </div>;
}
function SubSection({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div className="mt-4" data-id="element-791">
      <h3 className="text-base font-semibold text-navy mb-2" data-id="element-792">{title}</h3>
      <div className="text-gray-600 leading-relaxed [&_ul]:list-disc [&_ul]:list-inside [&_ul]:space-y-1 [&_ul]:ml-2" data-id="element-793">
        {children}
      </div>
    </div>;
}